import { useTranslation } from 'react-i18next';
import { Control, Controller, Path } from 'react-hook-form';
import { AppLanguage } from '@anytag/shared-types';
import { cn, localizedDateFormatter } from '@anytag/shared-utils';
import { TextCutter } from '../../TextCutter';
import { InputNumberProps, InputNumber } from '../../input';

interface ControlledFormRevenueInputProps<T extends Record<string, string | undefined>>
  extends Partial<InputNumberProps> {
  name: Path<T>;
  control: Control<T, any>;
  updatedTitle?: string;
  updatedDate?: string | null;
}
export const ControlledRevenueInput = <T extends Record<string, string | undefined>>({
  name,
  control,
  className,
  updatedDate,
  updatedTitle,
  ...inputProps
}: ControlledFormRevenueInputProps<T>) => {
  const { t, i18n } = useTranslation();

  return (
    <Controller<T>
      name={name}
      control={control}
      render={({ field }) => (
        <div className={cn('min-w-30', className)}>
          <InputNumber {...field} className="mr-auto w-full" {...inputProps} />
          <TextCutter
            lines={1}
            className="mt-0.5 text-left text-sm text-tertiary"
            text={`${updatedTitle || t('LUD')}: ${localizedDateFormatter(updatedDate || null, 'PPP', i18n.language as AppLanguage)}`}
          />
        </div>
      )}
    />
  );
};
